module.exports = __webpack_public_path__ + "img/Antonia&Stephan-05.08712cae.jpg";